// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"1819fe530824e1b7","6831":"5b35e6d7773e60d8","8503":"592caf82f9a2edd4","9683":"82cd12ef5390625b"}[chunkId] + ".js";
};